import React from "react";
// icons
import { IconPencil, IconUser } from "@tabler/icons-react";
// components
import PhotographerProfile from "../../pages/photographer/profile/photographerProfile.tsx";
import PhotographerProjects from "../../pages/photographer/projects/photographerProjects.tsx";
import ProjectDetail from "../../pages/photographer/projects/child/projectDetail.tsx";

export const PhotographerRoutes: any = {
    photographer: [
        {
            label: 'آپدیت پروفایل',
            address: '/photographer/panel',
            component: <PhotographerProfile />,
            icon: <IconUser
                size={20}
                className="ms-2 admin-menu-item-svg vertical-td" />
            ,
            items: [
                {
                    label: 'پروفایل',
                    address: '/photographer/panel',
                    show: true,
                },
            ]
        },
        {
            label: 'لیست پروژه ها',
            address: '/photographer/panel/projects',
            component: <PhotographerProjects />,
            icon: <IconPencil
                size={20}
                className="ms-2 admin-menu-item-svg vertical-td" />
            ,
            items: [
                {
                    label: 'پروژه ها',
                    address: '/photographer/panel/projects',
                    show: true,
                },
                {
                    label: 'آپلود عکس',
                    address: '/photographer/panel/projects/uploads',
                    component: <ProjectDetail />,
                    show: false,
                },
            ]
        },
    ],
}
